module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec02_img_01-efb6854a466586572030269a4c3883c3.png";